import {
  SkeletonBlock,
  SkeletonTitle,
  SolidSkeletonSection,
} from './generic-skeleton-placeholders';

export function ActivityFeedSkeleton() {
  return (
    <div className="w-full px-16">
      <div className="mb-[20px]">
        <SkeletonTitle width="60%" height={28} />
      </div>

      <div className="flex gap-[30px]">
        <div className="flex-1">
          {/* Timeline item 1 */}
          <div className="flex mb-[30px] relative">
            <div className="w-4 h-4 rounded-full mr-[10px] flex-shrink-0">
              <SolidSkeletonSection height={16} width={16} />
            </div>
            <div className="flex-1">
              <div className="flex justify-between items-center mb-[10px]">
                <SkeletonTitle height={15} width="40%" margin="0" />
                <SkeletonTitle height={10} width="20%" margin="0" />
              </div>
              <SkeletonBlock height={50} margin="0" />
            </div>
            <div className="absolute left-[8px] top-4 bottom-[-30px] w-[1px]">
              <SolidSkeletonSection height="100%" width={1} />
            </div>
          </div>

          {/* Timeline item 2 */}
          <div className="flex mb-[30px] relative">
            <div className="w-4 h-4 rounded-full mr-[10px] flex-shrink-0">
              <SolidSkeletonSection height={16} width={16} />
            </div>
            <div className="flex-1">
              <div className="flex justify-between items-center mb-[10px]">
                <SkeletonTitle height={15} width="50%" margin="0" />
                <SkeletonTitle height={10} width="20%" margin="0" />
              </div>
              <SkeletonBlock height={50} margin="0" />
            </div>
            <div className="absolute left-[8px] top-4 bottom-[-30px] w-[1px]">
              <SolidSkeletonSection height="100%" width={1} />
            </div>
          </div>

          {/* Timeline item 3 */}
          <div className="flex mb-[30px] relative">
            <div className="w-4 h-4 rounded-full mr-[10px] flex-shrink-0">
              <SolidSkeletonSection height={16} width={16} />
            </div>
            <div className="flex-1">
              <div className="flex justify-between items-center mb-[10px]">
                <SkeletonTitle height={15} width="45%" margin="0" />
                <SkeletonTitle height={10} width="25%" margin="0" />
              </div>
              <SkeletonBlock height={50} margin="0" />
            </div>
            <div className="absolute left-[8px] top-4 bottom-[-30px] w-[1px]">
              <SolidSkeletonSection height="100%" width={1} />
            </div>
          </div>

          {/* Timeline item 4 */}
          <div className="flex mb-[30px] relative">
            <div className="w-4 h-4 rounded-full mr-[10px] flex-shrink-0">
              <SolidSkeletonSection height={16} width={16} />
            </div>
            <div className="flex-1">
              <div className="flex justify-between items-center mb-[10px]">
                <SkeletonTitle height={15} width="55%" margin="0" />
                <SkeletonTitle height={10} width="25%" margin="0" />
              </div>
              <SkeletonBlock height={50} margin="0" />
            </div>
          </div>
        </div>

        <div className="w-[360px] flex-shrink-0">
          {/* Possible Violations section */}
          <div className="mb-[30px]">
            <SkeletonTitle height={20} width="70%" margin="0 0 20px 0" />

            {/* Violation item 1 */}
            <div className="mb-[15px]">
              <SkeletonTitle height={15} width="80%" margin="0 0 10px 0" />
              <div className="flex gap-[15px]">
                <SkeletonTitle height={12} width="25%" margin="0" />
                <SkeletonTitle height={12} width="50%" margin="0" />
              </div>
            </div>

            {/* Violation item 2 */}
            <div className="mb-[15px]">
              <SkeletonTitle height={15} width="70%" margin="0 0 10px 0" />
              <div className="flex gap-[15px]">
                <SkeletonTitle height={12} width="25%" margin="0" />
                <SkeletonTitle height={12} width="50%" margin="0" />
              </div>
            </div>
          </div>

          {/* Add Note section */}
          <div className="mb-[30px]">
            <SkeletonTitle height={20} width="40%" margin="0 0 15px 0" />
            <SkeletonBlock height={100} margin="0 0 15px 0" />
            <SolidSkeletonSection height={36} width={70} />
          </div>
        </div>
      </div>
    </div>
  );
}
